import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const CustomerEmiPage = () => {
  const [customerData, setCustomerData] = useState(null);
  const [repaymentData, setRepaymentData] = useState(null);
  const [loanDetails, setLoanDetails] = useState(null);
  const [error, setError] = useState('');

  const location = useLocation();
  const navigate = useNavigate();
  const id = new URLSearchParams(location.search).get('id');

  useEffect(() => {
    if (!id) return;

    api.get(`${base_url}/api/user/getApplicationDetailsById`, { params: { id } })
      .then(res => setCustomerData(res.data))
      .catch(() => setError('Error fetching customer data'));

    api.get(`${base_url}/api/approveRejectLoan/getRepaymentsById`, { params: { id } })
      .then(res => setRepaymentData(res.data))
      .catch(() => {});

    api.get(`${base_url}/api/userProduct/application`, { params: { id } })
      .then(res => setLoanDetails(res.data))
      .catch(() => {});
  }, [id]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' });
  };

  const navButtons = [
    { label: 'Profile', path: `/Profile?id=${id}` },
    { label: "Loans", path: `/LoanDetails?id=${id}` },
    { label: 'All EMI', path: `/EmiDetails?id=${id}` },
    { label: 'Report', path: `/CreditReport?id=${id}` },
  ];

  return (
    <div className="app-page">
      <TopBar title="Dashboard" />

      <div className="app-content">
        {error && <div className="app-card" style={{ color: '#e53935', textAlign: 'center' }}>{error}</div>}

        <div className="app-card" style={{ background: 'linear-gradient(135deg, #1d2e77, #2a3f9d)', color: '#fff', borderRadius: 14 }}>
          <p style={{ fontSize: 14, opacity: 0.8, marginBottom: 4 }}>Welcome back</p>
          <p style={{ fontSize: 22, fontWeight: 700, marginBottom: 16 }}>{customerData?.name || '—'}</p>

          {repaymentData && (
            <>
              <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 10, padding: 14, marginBottom: 0 }}>
                <p style={{ fontSize: 12, opacity: 0.8, marginBottom: 8 }}>
                  Loan #{repaymentData.loanId} · ₹{loanDetails?.loanAmount || '—'}
                </p>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div>
                    <p style={{ fontSize: 12, opacity: 0.7, marginBottom: 2 }}>Outstanding</p>
                    <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 0 }}>₹{repaymentData.outstandingPrincipal || '—'}</p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: 12, opacity: 0.7, marginBottom: 2 }}>Due Date</p>
                    <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 0 }}>{formatDate(repaymentData.dueDate)}</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 4 }}>
          {navButtons.map((btn, i) => (
            <button
              key={i}
              onClick={() => navigate(btn.path)}
              style={{
                background: '#fff', border: '1.5px solid #e0e0e0', borderRadius: 12,
                padding: '16px 8px', fontWeight: 700, fontSize: 14, color: '#1d2e77',
                cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              }}
            >
              {btn.label}
            </button>
          ))}
        </div>

        <div className="app-card">
          <p style={{ fontWeight: 700, color: '#1d2e77', marginBottom: 10 }}>Finance News</p>
          <ul style={{ paddingLeft: 18, margin: 0 }}>
            <li style={{ fontSize: 13, color: '#555', marginBottom: 8, lineHeight: 1.5 }}>
              Central Bank announces interest rate cut: Home and Auto Loans expected to become more affordable.
            </li>
            <li style={{ fontSize: 13, color: '#555', marginBottom: 8, lineHeight: 1.5 }}>
              RBI mandates banks to disclose comprehensive loan details.
            </li>
            <li style={{ fontSize: 13, color: '#555', lineHeight: 1.5 }}>
              RBI mandates interest calculation from actual disbursement date.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CustomerEmiPage;
